import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { ColorConversionState } from '@/store/types/color-conversion.state';

export const getters: GetterTree<ColorConversionState, RootState> = {

};